import { AxiosResponse, AxiosRequestConfig } from 'axios'

import { File } from '../interfaces/File.interface'
import { EmployeeComment } from '../interfaces/EmployeeComment.interface'
import { EmploymentStatus } from '../interfaces/EmploymentStatus.interface'
import { Employee, EmployeeFilterParams } from '../interfaces/Employee.interface'

import { employeesApi } from './'

import * as qs from 'query-string'

// export interface EmployeeListResponse {
//   count: number
//   results: Employee[]
// }

export interface EmployeeUpdateRequest {
  lastName?: string
  firstName?: string
  locationId?: number
  employmentStatus?: EmploymentStatus
}

export const getEmployees = (params?: EmployeeFilterParams) => {
  const axiosConfig: AxiosRequestConfig = {
    params,
    paramsSerializer: p => qs.stringify(p)
  }

  return employeesApi.get<Employee>('/employee', axiosConfig)
    .then((response: AxiosResponse) => response.data)
}

export const getEmployee = (employeeId: string) => (
  employeesApi.get<Employee>(`/employee/${employeeId}`)
    .then((response: AxiosResponse) => response.data)
)

export const getEmployeeFiles = (employeeId: string) => (
  employeesApi.get<File[]>(`/employee/${employeeId}/files`)
    .then((response: AxiosResponse) => response.data)
)

export const uploadEmployeeFile = (employeeId: string, file: any, confidential?: boolean) => {
  const formData = new FormData()
  formData.append('file', file)

  let url = `/employee/${employeeId}/files`
  if (confidential) { url = url + '/confidential' }
  
  return employeesApi.post(url, formData)
    .then((response: AxiosResponse) => response.data)
}

export const postEmployeeComment = (employeeId: string, comment: string) => {
  return employeesApi.post<EmployeeComment>(`/employee/${employeeId}/comment`, { comment })
    .then((response: AxiosResponse) => response.data)
}

export const getEmployeeComments = (employeeId: string) => {
  return employeesApi.get<EmployeeComment>(`/employee/${employeeId}/comment`)
    .then((response: AxiosResponse) => response.data)
}

export const updateEmployee = (employeeId: string, payload: EmployeeUpdateRequest) => (
  employeesApi.put<Employee>(`/employee/${employeeId}`, payload)
    .then((response: AxiosResponse) => response.data)
)



// WEBPACK FOOTER //
// ./src/lib/api/employees.ts